import React, { useState } from "react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs"
import SignupForm from "./components/SignupForm"
import VerificationStep from "./components/VerificationStep"

const Signup = () => {
    const [step, setStep] = useState("email")
    const [userType, setUserType] = useState("agent")
    const [email, setEmail] = useState("")

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light py-5 px-3">
            <div className="card shadow-lg w-100" style={{ maxWidth: '500px' }}>
                <div className="card-body">
                    <div className="text-center mb-4">
                        <h2 className="fw-bold text-dark">Create Account</h2>
                        <p className="text-muted small mt-2">
                            Join TariffTales as an Agent
                        </p>
                    </div>

                    <div className="p-4">
                        <Tabs defaultValue="agent">
                            <TabsList>
                                <TabsTrigger value="agent">Agent</TabsTrigger>
                            </TabsList>
                            <TabsContent value="agent">
                                <p>This is the Agent tab content.</p>
                            </TabsContent>
                        </Tabs>
                    </div>

                    <div className="tab-content">
                        <div
                            className={`tab-pane fade ${userType === 'agent' ? 'show active' : ''}`}
                        >
                            {step === 'email' && (
                                <SignupForm.Email
                                    email={email}
                                    setEmail={setEmail}
                                    onSubmit={() => setStep('verification')}
                                />
                            )}
                            {step === 'verification' && (
                                <VerificationStep
                                    email={email}
                                    onVerified={() => setStep('details')}
                                    onBack={() => setStep('email')}
                                />
                            )}
                            {step === 'details' && (
                                <SignupForm.Details
                                    userType="agent"
                                    email={email}
                                    onBack={() => setStep('verification')}
                                />
                            )}
                        </div>

                        <div
                            className={`tab-pane fade ${userType === 'shipper' ? 'show active' : ''}`}
                        >
                            {step === 'email' && (
                                <SignupForm.Email
                                    email={email}
                                    setEmail={setEmail}
                                    onSubmit={() => setStep('verification')}
                                />
                            )}
                            {step === 'verification' && (
                                <VerificationStep
                                    email={email}
                                    onVerified={() => setStep('details')}
                                    onBack={() => setStep('email')}
                                />
                            )}
                            {step === 'details' && (
                                <SignupForm.Details
                                    userType="shipper"
                                    email={email}
                                    onBack={() => setStep('verification')}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Signup
